export const CustomerListTableSkeleton = () => {
  return (
    <div className="w-full">
      <div className="h-[480px] w-full animate-pulse rounded-2xl bg-skeleton" />
    </div>
  )
}
